import type { PaDelegationMode, PaToolAvailability } from '@easyflow/shared';

const AVAILABILITY_LABELS: Record<PaToolAvailability['availability'], string> = {
  available: 'Disponibile',
  delegated: 'Disponibile con delega',
  disabled: 'Disabilitato nella selezione',
  role_denied: 'Escluso dal ruolo',
  unverifiable: 'Non verificabile',
};

export function PaSavedAuthoritySummary({ tools, mode, dirty, error }: { tools: PaToolAvailability[]; mode: PaDelegationMode | null; dirty: boolean; error: string | null }) {
  return (
    <section className="rounded-lg border p-3 space-y-2" aria-label="Disponibilità della configurazione salvata">
      <h4 className="text-sm font-medium">Disponibilità della configurazione salvata</h4>
      {mode && <p className="text-xs text-muted-foreground">Modalità salvata: {mode === 'delegated' ? 'Consenti delega' : 'Rispetta i permessi dell’utente'}</p>}
      {dirty && <p className="text-sm text-warning">Riepilogo non valido per la bozza: salva prima le modifiche a utente o strumenti.</p>}
      {error && <p role="alert" className="text-sm text-destructive">Confronto non verificabile: {error}</p>}
      <p className="text-xs text-muted-foreground">
        {tools.filter(tool => tool.selected).length} strumenti selezionati · {tools.filter(tool => tool.availability === 'available' || tool.availability === 'delegated').length} disponibili · {tools.filter(tool => tool.availability === 'role_denied').length} esclusi dal ruolo · {tools.filter(tool => tool.availability === 'unverifiable').length} non verificabili
      </p>
      <details>
        <summary className="cursor-pointer text-xs font-medium">Mostra requisiti e motivi</summary>
        <ul className="mt-2 max-h-56 overflow-y-auto divide-y text-xs">
          {tools.map(tool => <li key={JSON.stringify([tool.server_id, tool.tool_name])} className="py-2 space-y-1">
            <p className="font-medium break-all">{tool.tool_name} <span className="font-normal text-muted-foreground">({tool.server_id})</span></p>
            <p>Selezione: {tool.selected ? 'abilitato' : 'disabilitato'} · Requisito: {tool.required_permission || 'vedi motivo'} · {AVAILABILITY_LABELS[tool.availability]}</p>
            {tool.reason && <p className="text-muted-foreground">{tool.reason}</p>}
          </li>)}
        </ul>
      </details>
      <p className="text-xs text-muted-foreground">Restano i controlli sui dati, sui mittenti e le eventuali conferme. La disponibilità non garantisce il successo di ogni operazione.</p>
    </section>
  );
}